import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import DeleteItem from "../DeleteItem";

import {
  IconTrash,
} from "@tabler/icons-react";
import {
  deleteEducationTypeApi,
  getEducationTypeApi,
} from "../../../Api/EducationType";
import SideModal from "../../general/Sidemodal";
import { EducationTypeForm } from "./EducationTypeForm";

interface Props {
  url: string; 
}

export function EducationType({ url }: Props) {
  interface EducationType {
    id: string;
    name: string;
  }

  const [EducationTypes, setEducationTypes] = useState<EducationType[]>([]);
  const [search, setSearch] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<{ id: string } | null>(null);

  const navigate = useNavigate();

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);

  const handleAddClick = () => {
    setEditId(null);
    setIsFormModalOpen(true);
  };

  const handleEditClick = (id: string) => {
    setEditId(id);
    setIsFormModalOpen(true);
  };

  const handleDeleteClick = (id: string) => {
    setSelectedItem({ id });
    setIsModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedItem) return;

    try {
      await deleteEducationTypeApi(selectedItem.id, url);
      handleApiCallClick();
      toast.success("Deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete." + error);
    } finally {
      setIsModalOpen(false);
      setSelectedItem(null);
    }
  };

  const handleApiCallClick = async () => {
    try {
      const educationTypeData: any = await getEducationTypeApi(url);
      setEducationTypes(educationTypeData);
    } catch (error) {
      toast.error(
        "Failed to fetch Education type data. Some problem occurred. Please try again."
      );
    }
  };

  useEffect(() => {
    handleApiCallClick();
  }, []);

  return (
    <div className="px-2 md:px-4 mt-6">

      <div className='flex flex-row items-center '>
        <h2 className="text-3xl font-bold text-blue-600 mb-5">Education Type</h2>
        <button
          type="button"
          className=" w-fit px-3 py-2 mx-3 mb-4 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
       onClick={handleAddClick}
        >
          <FaPlus className="w-3 h-3" />
        </button>
      </div>
      <input
        type="text"
        placeholder="Search by Education Type"
        className="w-full mb-6 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 md:rounded-lg">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th
                scope="col"
                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
              >
                Action
              </th>

              <th className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400">
                Education Type
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
            {EducationTypes.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td className="px-4 py-4 text-sm whitespace-nowrap">
                  <div className="flex items-center gap-x-3">
                    <IconTrash
                      className="cursor-pointer text-gray-500 transition-colors duration-200 hover:text-red-500"
                      onClick={() => handleDeleteClick(item.id)}
                    />
                    <button
                      onClick={() => handleEditClick(item.id)}
                      className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        className="w-5 h-5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
                <td className="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">
                  {item.name}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      {isModalOpen && (
        <DeleteItem onClose={() => setIsModalOpen(false)} onConfirm={confirmDelete} />
      )}

      <SideModal isOpen={isFormModalOpen} onClose={() => setIsFormModalOpen(false)}>
        <EducationTypeForm url={url} editId={editId} onClose={() => setIsFormModalOpen(false)} 
        onSaved={handleApiCallClick} />
      </SideModal>
    </div>
  );
}
